import { render, staticRenderFns } from "./creatAttr.vue?vue&type=template&id=6013c2c0&scoped=true"
import script from "./creatAttr.vue?vue&type=script&lang=js"
export * from "./creatAttr.vue?vue&type=script&lang=js"
import style0 from "./creatAttr.vue?vue&type=style&index=0&id=6013c2c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6013c2c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6013c2c0')) {
      api.createRecord('6013c2c0', component.options)
    } else {
      api.reload('6013c2c0', component.options)
    }
    module.hot.accept("./creatAttr.vue?vue&type=template&id=6013c2c0&scoped=true", function () {
      api.rerender('6013c2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/components/creatAttr.vue"
export default component.exports